import React, { useState, useEffect } from 'react';
import './info.css';
import MessageCard from '../message-card/MessageCard';

const StudentInfo = ({ data , token}) => {
    //console.log(data);

    const [progressTextThesis, setProgressTextThesis] = useState('');
    const [progressTextSim, setProgressTextSim] = useState('');
    const [progressTextCode, setProgressTextCode] = useState('');

    const [driveLinkThesis, setDriveLinkThesis] = useState(null);
    const [driveLinkSim, setDriveLinkSim] = useState(null);
    const [driveLinkCode, setDriveLinkCode] = useState(null);

    useEffect(() => {
        try {
          // Trigger Google ads by pushing to adsbygoogle array
          (window.adsbygoogle = window.adsbygoogle || []).push({});
        } catch (e) {
          console.error("Adsense error", e);
        }
      }, []);

    useEffect(() => {
        if (driveLinkThesis !== null) {
            //console.log(driveLinkThesis);
            async function fetchData(){
                try {
        
                    const response = await fetch('https://7m6qc50xjh.execute-api.ap-south-1.amazonaws.com/api/update-file-link', {
                    //const response = await fetch('http://localhost:3000/api/update-file-link', {
                        method: 'POST',
                        headers: {
                            'Authorization': token,
                            'Content-Type': 'application/json'
                        },
                        credentials: 'include',
                        body: JSON.stringify({
                            link_for: "Thesis",
                            name: data.fypGroup.name,
                            link: driveLinkThesis['link']
                        })
                    });
    
                    if (!response.ok) {
                        throw new Error('Failed');
                    }
    
                    //const responseData = await response.json();
                    setLabelTextThesis('Your thesis has been uploaded successfully. Refresh the page for the thesis file link.');
                    //thesisCard.style.pointerEvents = 'auto';
                } catch (error) {
                    alert('Error occured at server: ', error);
                }
            }
            fetchData();
        }
    }, [driveLinkThesis]);

    // Function to set label handleThesisUploadtext dynamically
    const setLabelTextThesis = (text) => {
        setProgressTextThesis(text);
    };

    useEffect(() => {
        if (driveLinkSim !== null) {
            //console.log(driveLinkSim);
            async function fetchData(){
                try {
        
                    const response = await fetch('https://7m6qc50xjh.execute-api.ap-south-1.amazonaws.com/api/update-file-link', {
                    //const response = await fetch('http://localhost:3000/api/update-file-link', {
                        method: 'POST',
                        headers: {
                            'Authorization': token,
                            'Content-Type': 'application/json'
                        },
                        credentials: 'include',
                        body: JSON.stringify({
                            link_for: "Similarty",
                            name: data.fypGroup.name,
                            link: driveLinkSim['link']
                        })
                    });
    
                    if (!response.ok) {
                        throw new Error('Failed');
                    }
    
                    //const responseData = await response.json();
                    setLabelTextSim('Your similarity report has been uploaded successfully. Refresh the page for the similarity report file link.');
                    //thesisCard.style.pointerEvents = 'auto';
                } catch (error) {
                    alert('Error occured at server: ', error);
                }
            }
            fetchData();
        }
    }, [driveLinkSim]);

    // Function to set label text dynamically
    const setLabelTextSim = (text) => {
        setProgressTextSim(text);
    };

    useEffect(() => {
        if (driveLinkCode !== null) {
            //console.log(driveLinkSim);
            async function fetchData(){
                try {
        
                    const response = await fetch('https://7m6qc50xjh.execute-api.ap-south-1.amazonaws.com/api/update-file-link', {
                    //const response = await fetch('http://localhost:3000/api/update-file-link', {
                        method: 'POST',
                        headers: {
                            'Authorization': token,
                            'Content-Type': 'application/json'
                        },
                        credentials: 'include',
                        body: JSON.stringify({
                            link_for: "Code",
                            name: data.fypGroup.name,
                            link: driveLinkCode['link']
                        })
                    });
    
                    if (!response.ok) {
                        throw new Error('Failed');
                    }
    
                    //const responseData = await response.json();
                    setLabelTextCode('Your code has been uploaded successfully. Refresh the page for the code folder link.');
                    //thesisCard.style.pointerEvents = 'auto';
                } catch (error) {
                    alert('Error occured at server: ', error);
                }
            }
            fetchData();
        }
    }, [driveLinkCode]);

    // Function to set label text dynamically
    const setLabelTextCode = (text) => {
        setProgressTextCode(text);
    };

/*----------------------------------------------------------------------*/

    const handleThesisUpload = async () => {
        const fileInput = document.getElementById('thesis-upload');
        const file = fileInput.files[0];
        //if (file && file.type === 'application/pdf') {
        if (false) {
            const reader = new FileReader();
            reader.onerror = (errorEvent) => {
                throw new Error('Error reading file}'); 
            };
            reader.onloadend = async (e) => {
                if (e.target && e.target.readyState === FileReader.DONE) {
                    const uploadData = {
                        folderName: data.fypGroup.name,
                        fileName: "thesis_" + data.student.name,
                        fileData: reader.result
                    };
                    try {
                        const thesisCard = document.getElementById('thesis-upload-card');
                        thesisCard.style.pointerEvents = 'none';
                        setLabelTextThesis('Please wait while your thesis is being uploaded');
                
                        const response = await fetch('https://script.google.com/macros/s/AKfycbwP3owUZO0jnykmnvIWXEFkLjd2MBRegPhW2FqOLTQx6xdKNvPo5EvOY-zqlKIaA5pGWA/exec', {
                            method: 'POST',
                            headers: {
                                'content-type': 'text/plain;charset=utf-8'
                            },
                            body: JSON.stringify(uploadData)
                        });
        
                        if (!response.ok) {
                            throw new Error('Failed to upload file');
                        }
        
                        const responseData = await response.json();
                        setDriveLinkThesis(responseData)
                    } catch (error) {
                        alert('Error uploading file: ', error);
                    }
                }
            };
            reader.readAsDataURL(file);            
        } else {
            //alert('Please select a PDF file.');
            alert('The FYP Session is now closed. You cannot upload your thesis now.');
        }
    };

    const handleSimUpload = async () => {
        const fileInput = document.getElementById('sim-upload');
        const file = fileInput.files[0];
        //if (file && file.type === 'application/pdf') {
        if(false) {
            const reader = new FileReader();
            reader.onerror = (errorEvent) => {
                throw new Error('Error reading file}'); 
            };
            reader.onloadend = async (e) => {
                if (e.target && e.target.readyState === FileReader.DONE) {
                    const uploadData = {
                        folderName: data.fypGroup.name,
                        fileName: "simReport_" + data.student.name,
                        fileData: reader.result
                    };
                    try {
                        const thesisCard = document.getElementById('sim-upload-card');
                        thesisCard.style.pointerEvents = 'none';
                        setLabelTextSim('Please wait while your similarity report is being uploaded');
                
                        const response = await fetch('https://script.google.com/macros/s/AKfycbz56W5PsAc6vazsPs8-jKSUXoRnto9sVOefPWAm92ZOpITCA43J43tpVAZz4tXoIQ/exec', {
                            method: 'POST',
                            headers: {
                                'content-type': 'text/plain;charset=utf-8'
                            },
                            body: JSON.stringify(uploadData)
                        });
        
                        if (!response.ok) {
                            throw new Error('Failed to upload file');
                        }
        
                        const responseData = await response.json();
                        setDriveLinkSim(responseData)
                    } catch (error) {
                        alert('Error uploading file: ', error);
                    }
                }
            };
            reader.readAsDataURL(file);            
        } else {
            //alert('Please select a PDF file.');
            alert('The FYP Session is now closed. You cannot upload your thesis now.');
        }
    };

    const handleFileChange = (e) => {
        const selectedFile = e.target.files[0];
        const maxSizeInMB = 30;
        const maxSizeInBytes = maxSizeInMB * 1024 * 1024;
    
        if (selectedFile && selectedFile.size > maxSizeInBytes) {
            //document.getElementById('code-upload').value = null;
            const fileInput = document.getElementById('code-upload');
            if (fileInput) {
               fileInput.value = ''; // Clear the file input
               setLabelTextCode(`File size exceeds ${maxSizeInMB}MB.`);
            }
        }
        else {
            setLabelTextCode('');
        }
    }

    const handleCodeUpload = async () => {
        const fileInput = document.getElementById('code-upload');
        const file = fileInput.files[0];
        //if (file && file.type === 'application/zip') {
        if(false) {
            const reader = new FileReader();
            reader.onerror = (errorEvent) => {
                throw new Error('Error reading file}'); 
            };
            reader.onloadend = async (e) => {
                if (e.target && e.target.readyState === FileReader.DONE) {
                    const uploadData = {
                        folderName: data.fypGroup.name,
                        fileName: "code_" + data.student.name,
                        fileData: reader.result//.split(',')[1]
                    };
                    try {
                        const thesisCard = document.getElementById('code-upload-card');
                        thesisCard.style.pointerEvents = 'none';
                        setLabelTextCode('Please wait while your code is being uploaded');
                
                        const response = await fetch('https://script.google.com/macros/s/AKfycby32uxsO2qTiyg7EWTC4bnamC9TBwD-71UOXF7JPlnn-G0TqQM2O_uw6fMTw1nObe998A/exec', {
                            method: 'POST',
                            headers: {
                                'content-type': 'text/plain;charset=utf-8'
                            },
                            body: JSON.stringify(uploadData)
                        });
        
                        if (!response.ok) {
                            throw new Error('Failed to upload file');
                        }
        
                        const responseData = await response.json();
                        setDriveLinkCode(responseData)
                    } catch (error) {
                        alert('Error uploading file: ', error);
                    }
                }
            };
            reader.readAsDataURL(file);            
        } else {
            //alert('Please select a ZIP file.');
            alert('The FYP Session is now closed. You cannot upload your thesis now.');
        }
    };

    if (!data.status){
        return (
            <MessageCard message={data.message} isError={false} />
        );
    }

    const groupMembers = data.groupMembers.map(member => member.name).join(', ');
    const assessMapping = {
        oct: { name: 'October', totalMarks: 0 },
        nov: { name: 'November', totalMarks: 10 },
        dec: { name: 'December', totalMarks: 10 },
        feb: { name: 'February', totalMarks: 10 },
        mar: { name: 'March', totalMarks: 10 },
        apr: { name: 'April', totalMarks: 10 },
        sim: { name: 'Thesis Similarity Report', totalMarks: 20 },
        int: { name: 'Internal Viva', totalMarks: 50 },
        ext: { name: 'External Viva', totalMarks: 50 },
        ths: { name: 'Thesis (hard copy) and Code', totalMarks: 30 },
        evt: { name: 'Events Participation', totalMarks: 0 },
        // ... add other months as needed
    };

    return (
        <div className="marks-container">
            {data && data.student && data.fypGroup ? (
                <>
                    <div className="marks-card">
                        <p>Your Group Info</p>
                        <table>
                            <tbody>
                                <tr>
                                    <td>Name</td>
                                    <td>{data.student.name}</td>
                                </tr>
                                <tr>
                                    <td>Roll Number</td>
                                    <td>{data.student.roll_num}</td>
                                </tr>
                                <tr>
                                    <td>Program</td>
                                    <td>{data.student.program}</td>
                                </tr>
                                <tr>
                                    <td>FYP Group Name</td>
                                    <td>{data.fypGroup.name}</td>
                                </tr>
                                <tr>
                                    <td>FYP Group Members</td>
                                    <td>{groupMembers}</td>
                                </tr>
                                <tr>
                                    <td>FYP Title</td>
                                    <td>{data.fypGroup.title}</td>
                                </tr>
                                <tr>
                                    <td>FYP Category</td>
                                    <td>{data.fypGroup.cat}</td>
                                </tr>
                                <tr>
                                    <td>Supervisor</td>
                                    <td>{data.student.supervisor}</td>
                                </tr>
                                <tr>
                                    <td>External Examiner</td>
                                    <td>{data.student.external}</td>
                                </tr>
                                <tr>
                                    <td>Thesis File</td>
                                    <td>
                                        {data.fypGroup.marks[9].lnk != '' ? (
                                            <a href={data.fypGroup.marks[9].lnk} target="_blank" rel="noopener noreferrer">Open the file</a>
                                        ) : (
                                            "Thesis not yet uploaded"
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Similarity Report File</td>
                                    <td>
                                        {data.fypGroup.marks[8].lnk != '' ? (
                                            <a href={data.fypGroup.marks[8].lnk} target="_blank" rel="noopener noreferrer">Open the file</a>
                                        ) : (
                                            "Similarity Report not yet uploaded"
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td>FYP Code Zip Folder</td>
                                    <td>
                                        {data.fypGroup.marks[10].lnk != '' ? (
                                            <a href={data.fypGroup.marks[10].lnk} target="_blank" rel="noopener noreferrer">Open the file</a>
                                        ) : (
                                            "Code ZIP not yet uploaded"
                                        )}
                                    </td>
                                </tr>
                                <tr>
                                    <td>Thesis Hard Copy Submission</td>
                                    <td>
                                        {data.bindReady ? (
                                            <h5 style={{ color: 'green' }}>Ready</h5>
                                        ) : (
                                            <h5 style={{ color: 'red' }}>Not Ready</h5>
                                        )}
                                    </td>
                                </tr> 
                            </tbody>
                        </table>
                    </div>
                    <div className="marks-card">
                        <ins className="adsbygoogle"
                            style={{ display: 'block' }}
                            data-ad-client="ca-pub-3857617086278127"
                            data-ad-slot="2655139414"
                            data-ad-format="auto"
                            data-full-width-responsive="true"></ins>
                        <script
                            async
                            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3857617086278127"
                            crossOrigin="anonymous">
                        </script>
                    </div>
                    { <div className="marks-card">
                        <p>Your Marks</p>
                        <table>
                            <thead>
                                <tr>
                                    <th>Assesment</th>
                                    <th>Total Marks</th>
                                    <th>Marks Obtained</th>
                                </tr>
                            </thead>
                            <tbody>
                                {data.fypGroup.marks.slice(0, 11).map((mark, index) => (
                                    <tr key={index}>
                                        <td>{assessMapping[mark.marks_for]?.name || mark.marks_for}</td>
                                        <td>{assessMapping[mark.marks_for]?.totalMarks || 'N/A'}</td>
                                        <td>{mark.obt}</td>
                                    </tr>
                                ))}
                            </tbody>
                        </table>
                    </div> }
                    <div className="marks-card">
                        <ins className="adsbygoogle"
                            style={{ display: 'block' }}
                            data-ad-client="ca-pub-3857617086278127"
                            data-ad-slot="2655139414"
                            data-ad-format="auto"
                            data-full-width-responsive="true"></ins>
                        <script
                            async
                            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3857617086278127"
                            crossOrigin="anonymous">
                        </script>
                    </div>
                    <div id="thesis-upload-card" className="card">
                        <p>Upload Your Thesis for Evaluation</p>
                        <input
                            id="thesis-upload"
                            type="file"
                            accept=".pdf"
                            //onChange={this.handleFileUpload}
                        />
                        <span className="button-space"></span>
                        <button onClick={handleThesisUpload}>Upload</button>
                        <span className="button-space"></span>
                        <label id="progress">{progressTextThesis}</label>
                    </div>

                    <div className="marks-card">
                        <ins className="adsbygoogle"
                            style={{ display: 'block' }}
                            data-ad-client="ca-pub-3857617086278127"
                            data-ad-slot="2655139414"
                            data-ad-format="auto"
                            data-full-width-responsive="true"></ins>
                        <script
                            async
                            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3857617086278127"
                            crossOrigin="anonymous">
                        </script>
                    </div>

                    <div id="sim-upload-card" className="card">
                        <p>Upload Your Thesis Similarity Report for Evaluation</p>
                        <input
                            id="sim-upload"
                            type="file"
                            accept=".pdf"
                            //onChange={this.handleFileUpload}
                        />
                        <span className="button-space"></span>
                        <button onClick={handleSimUpload}>Upload</button>
                        <span className="button-space"></span>
                        <label id="progress">{progressTextSim}</label>
                    </div>

                    <div className="marks-card">
                        <ins className="adsbygoogle"
                            style={{ display: 'block' }}
                            data-ad-client="ca-pub-3857617086278127"
                            data-ad-slot="2655139414"
                            data-ad-format="auto"
                            data-full-width-responsive="true"></ins>
                        <script
                            async
                            src="https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=ca-pub-3857617086278127"
                            crossOrigin="anonymous">
                        </script>
                    </div>

                    <div id="code-upload-card" className="card">
                        <p>Upload Your Project Code.  
                            <a href="https://drive.google.com/file/d/1_9pBYZOTAtH5EClYU-yhDTbAWccZTS9j/view?usp=drive_link" target="_blank" rel="noopener noreferrer"> Read the instructions</a>
                        </p>
                        <input
                            id="code-upload"
                            type="file"
                            accept=".zip"
                            onChange={handleFileChange}
                        />
                        <span className="button-space"></span>
                        <button onClick={handleCodeUpload}>Upload</button>
                        <span className="button-space"></span>
                        <label id="progress">{progressTextCode}</label>
                    </div> 
                </>
            ) : (
                <p>Arranging Fetched Data..</p>
            )}
        </div>
                
    );
};

export default StudentInfo;